import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const ServicesPreview = () => {
  const services = [
    {
      id: "otomotiv-cozumleri",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9L18.4 9.3c-.3-.8-1-1.3-1.9-1.3H7.5c-.9 0-1.6.5-1.9 1.3L3.5 11.1C2.7 11.3 2 12.1 2 13v3c0 .6.4 1 1 1h2m14 0H5m14 0v3c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1v-3"/>
          <circle cx="7" cy="17" r="2"/>
          <circle cx="17" cy="17" r="2"/>
        </svg>
      ),
      title: "🚗 Otomotiv Çözümleri",
      description: "Otomotiv alanındaki uzmanlığımız ile müşterilerimize araçlarının kullanım konforunu ve fonksiyonelliğini artıracak yenilikçi çözümler sunuyoruz."
    },
    {
      id: "yazilim-cozumleri",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      ),
      title: "💻 Yazılım Çözümleri",
      description: "Yazılım alanında bireysel kullanıcıların ve işletmelerin ihtiyaçlarına özel çözümler geliştiriyoruz."
    }
  ];

  return (
    <section className="section services-preview">
      <div className="container">
        <h2 className="section-title">Hizmetlerimiz</h2>
        <p className="section-subtitle">
          Teknolojinin gücünü kullanarak işletmenizin ihtiyaçlarına özel çözümler sunuyoruz.
        </p>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-overlay">
                <Link to="/services" className="btn btn-outline">Detayları Gör</Link>
              </div>
            </div>
          ))}
        </div>
        
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/services" className="btn">Tüm Hizmetlerimiz</Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;

